export const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (!element) return;
    element.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
    });
};

export const formatMongoDate = (date: Date | string | number): string => {
    if (!date) return "";
    const d = new Date(date);

    return d.toLocaleString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
};

export const cutName = (n: string, limit = 30): string =>
    n && n.length > limit ? `${n.slice(0, limit)}…` : n;

export const formatMinutes = (decimalMinutes: number): string => {
    if (!Number.isFinite(decimalMinutes) || decimalMinutes <= 0) return "0m";

    const totalSeconds = Math.round(decimalMinutes * 60);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return seconds > 0 ? `${minutes}m ${seconds}s` : `${minutes}m`;
};

const formatSize = (bytes?: number | null): string => {
    if (bytes == null) return "-";

    // Added space before the unit (e.g., "8.4 MB")
    if (bytes < 1024 * 1024) {
        return `${Math.round(bytes / 1024)} KB`;
    }

    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const formatDuration = (minutes?: number | null): string => {
    if (minutes == null || minutes <= 0) return "-";

    const totalSeconds = Math.round(minutes * 60);
    const m = Math.floor(totalSeconds / 60);
    const s = totalSeconds % 60;

    // Short and clean
    return s > 0 ? `${m}m ${s}s` : `${m}m`;
};

export const formatAudioMeta = (
    bytes?: number | null,
    minutes?: number | null,
): string => {
    // Added spaces around the slash: "8.4 MB / 2m 55s"
    const size = formatSize(bytes);
    const duration = formatDuration(minutes);
    return size !== "-" && duration !== "-" ? `${size} / ${duration}` : "-";
};

export const formatRange = (start: number, end: number) => {
    const format = (s: number) => {
        const total = Math.max(0, s);
        const m = Math.floor(total / 60);
        const sec = Math.floor(total % 60);

        // Using "s" for seconds is very native
        if (m === 0) return `${total.toFixed(1)}s`;

        return `${m}:${sec.toString().padStart(2, "0")}`;
    };

    const a = Math.min(start, end);
    const b = Math.max(start, end);

    // Using the en-dash (–) for ranges is a nice professional touch
    return `${format(a)} – ${format(b)}`;
};

export const formatCuesTime = (sec: number) => {
    const m = Math.floor(sec / 60)
        .toString()
        .padStart(2, "0");
    const s = Math.floor(sec % 60)
        .toString()
        .padStart(2, "0");
    return `${m}:${s}`;
};

export const formatImg = (url: string, width: number | string) => {
    if (!url) return '';
    // Append Bunny Optimizer params
    return `${url}?width=${width}&format=webp&quality=80`;
}

export const getInitials = (firstName: string, lastName: string) => {
    const first = firstName?.charAt(0) || "";
    const last = lastName?.charAt(0) || "";

    return (first + last).toUpperCase();
};
